/**
 * Compliance Routes
 * ============================================================================
 *
 * Tenant-side compliance surfaces. Currently houses the document
 * verification queue; future additions (KYC dashboard, audit log
 * viewer, expiration alerts) will live here too.
 *
 * Per-page authorisation: the page itself is gated only by the
 * backend `document:verify` permission via the API. The sidebar
 * link is hidden for users without that permission, but anyone with
 * the route can still land on the page and hit a "no pending" view
 * if the API returns an empty queue.
 * ============================================================================
 */

import { LAYOUT_TYPES, ROUTE_PATHS } from 'navigation/constants';

import type { RouteGroup } from 'navigation/types';
import { lazy } from 'react';

const ComplianceQueuePage = lazy(
  () => import('@/features/documents/ui/pages/compliance-queue-page')
);

export const complianceRoutes: RouteGroup = {
  name: 'compliance',
  layout: LAYOUT_TYPES.DASHBOARD,
  permission: {
    requiresAuth: true,
  },
  routes: [
    {
      path: ROUTE_PATHS.COMPLIANCE_DOCUMENTS,
      component: ComplianceQueuePage,
      meta: {
        title: 'common:compliance.queueTitle',
        showInNav: true,
      },
    },
  ],
};
